var _circle, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClass(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.7157 6.71573 0 15 0C23.2843 0 30 6.7157 30 15ZM29 15C29 22.732 22.732 29 15 29C7.26802 29 1 22.732 1 15C1 7.26801 7.26802 1 15 1C22.732 1 29 7.26801 29 15ZM15.7725 10.5995C17.0123 10.2943 17.9318 9.17496 17.9318 7.84091C17.9318 6.27192 16.6599 5 15.0909 5C13.5219 5 12.25 6.27192 12.25 7.84091C12.25 9.18292 13.1805 10.3076 14.4316 10.6049L12.3958 14.6533C12.3289 14.7863 12.4256 14.9432 12.5744 14.9432H17.609C17.7575 14.9432 17.8542 14.7871 17.7881 14.6541L15.7725 10.5995ZM8.11347 19.7234C8.85737 19.5402 9.40909 18.8686 9.40909 18.0682C9.40909 17.1268 8.64594 16.3636 7.70455 16.3636C6.76315 16.3636 6 17.1268 6 18.0682C6 18.8734 6.55832 19.5482 7.30895 19.7266L6.14576 22.0397C6.07887 22.1727 6.17556 22.3296 6.32444 22.3296H9.08631C9.23479 22.3296 9.3315 22.1735 9.2654 22.0405L8.11347 19.7234ZM16.7955 21.0985C16.7955 21.8989 16.2438 22.5705 15.4999 22.7536L16.6518 25.0708C16.7179 25.2038 16.6212 25.3598 16.4727 25.3598H13.7108C13.5619 25.3598 13.4653 25.203 13.5321 25.07L14.6953 22.7569C13.9447 22.5785 13.3864 21.9037 13.3864 21.0985C13.3864 20.1571 14.1495 19.3939 15.0909 19.3939C16.0323 19.3939 16.7955 20.1571 16.7955 21.0985ZM22.8862 19.7234C23.6301 19.5402 24.1818 18.8686 24.1818 18.0682C24.1818 17.1268 23.4186 16.3636 22.4773 16.3636C21.5359 16.3636 20.7727 17.1268 20.7727 18.0682C20.7727 18.8734 21.331 19.5482 22.0817 19.7266L20.9185 22.0397C20.8516 22.1727 20.9483 22.3296 21.0971 22.3296H23.859C24.0075 22.3296 24.1042 22.1735 24.0381 22.0405L22.8862 19.7234Z",
    fill: "current",
    stroke: "current",
    strokeWidth: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/Class.f4d9eb23.svg";
export { ForwardRef as ReactComponent };